.signet-radio {
  display: block;
  height: 2rem;

  &.inline {
    display: inline-block;
  }

  .input-wrapper {
    display: flex;
    align-items: end;

    .radio-button {
      visibility: hidden;
      position: absolute;

      &:checked {
        & + .radio-label {
          &:before {
            border-color: var(--primary-main);
          }

          &:after {
            transform: scale(1);
          }
        }
      }

      &:disabled {
        & + .radio-label {
          opacity: 0.7;
          cursor: not-allowed;
        }
      }
    }

    .radio-label {
      display: inline-block;
      min-height: 1.25em;
      position: relative;
      padding-left: 1.75em;
      margin-bottom: 0;
      cursor: pointer;
      vertical-align: bottom;

      &:before,
      &:after {
        position: absolute;
        content: "";
        border-radius: 50%;
        transition-property: transform, border-color;
        transition: all 0.3s ease-in-out;
      }

      &:before {
        left: 0;
        top: 3px;
        width: 16px;
        height: 16px;
        border: 1px solid var(--gray-300);
      }

      &:after {
        top: 27%;
        left: 3px;
        width: 0.625em;
        height: 0.625em;
        transform: scale(0);
        background: var(--primary-main);
      }
    }
  }
}
